export const clamp = (v:number, min:number, max:number) => v < min ? min : (v > max ? max : v);
export const clampWrap = (v:number, min:number, max:number) => v < min ? max : (v > max ? min : v);